// extracted by mini-css-extract-plugin
module.exports = {"table":"ContentBoxTable_table__1m4YJ"};